export const deviceTypes = ['phone', 'tablet']
export const osTypes= ['android', 'iOS']



// WEBPACK FOOTER //
// ./src/constants/misc.js